const ApiError = {
  // A API responde erro de tres formas: 500 com { erros: [...] },
  // 400 com a mensagem em string pura e 401 sem corpo.
  Messages(erro) {
    let data = erro && erro.response ? erro.response.data : null;

    if (data && Array.isArray(data.erros) && data.erros.length > 0)
      return data.erros;

    if (typeof data === "string" && data.trim().length > 0) return [data];

    if (data && typeof data.message === "string" && data.message.length > 0)
      return [data.message];

    return ["Não foi possível concluir a operação. Tente novamente."];
  }
};

export default ApiError;
